import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import Button from "shared/components/FormElements/Button";
import { AuthContext } from "shared/context/auth-context";

const bannerStyle = {
  background: "linear-gradient(135deg, #fff3cd 0%, #ffe8a1 100%)",
  border: "1px solid #ffc107",
  borderRadius: "12px",
  padding: "20px 24px",
  marginBottom: "24px",
  display: "flex",
  alignItems: "center",
  gap: "16px",
  boxShadow: "0 4px 12px rgba(255, 193, 7, 0.15)",
};

const iconWrapperStyle = {
  width: "48px",
  height: "48px",
  borderRadius: "50%",
  backgroundColor: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "24px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  flexShrink: 0,
};

/**
 * Yellow warning banner when email is not verified and/or demo mode.
 * Includes "Go to dashboard" (same Button style as resend email on Dashboard) so users can open the dashboard to resend verification.
 */
const EmailVerificationBanner = ({ className = "", containerStyle = {} }) => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const isEmailVerified = auth.client?.emailConfirmed;
  const isDemo = auth.company?.isDemo;

  if (isEmailVerified && !isDemo) return null;

  return (
    <div className={className} style={{ ...bannerStyle, ...containerStyle }}>
      <div style={iconWrapperStyle}>🔒</div>
      {!isEmailVerified && (
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", minWidth: 0 }}>
            <div style={{ fontWeight: "bold", fontSize: "16px", color: "#856404" }}>
              {t("emailVerificationWarning.emailVerificationRequired")}
            </div>
            <div style={{ color: "#6c5a00", fontSize: "14px" }}>
              {t("emailVerificationWarning.verifyEmailToAccessFeatures")}
            </div>
          </div>
          <Button to="/dashboard" size="small">
            {t("emailVerificationWarning.goToDashboard")}
          </Button>
        </div>
      )}
      {isDemo && (
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: "bold", fontSize: "16px", color: "#856404", marginBottom: "4px" }}>
            {t("demoWarning.notAvailableInDemoMode")}
          </div>
          <div style={{ color: "#6c5a00", fontSize: "14px" }}>{t("demoWarning.notAvailableInDemoModeDescription")}</div>
        </div>
      )}
    </div>
  );
};

export default EmailVerificationBanner;
